import {useLocation} from 'react-router-dom';
import {useEffect} from 'react';
import {useAppDispatch} from '../../redux/hooks';

// Action type constants
export const LOCATION_CHANGE = 'router/locationChange';

// Action creator
export const locationChange = (location: any) => ({
  type: LOCATION_CHANGE,
  payload: {location}
});

/**
 * LocationSync component
 *
 * This component syncs the current location with Redux store
 * It's a replacement for the connected-react-router functionality
 */
function LocationSync() {
  const location = useLocation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(locationChange(location));
  }, [location, dispatch]);

  return null;
}

export default LocationSync;